import { IonRow, IonCol } from '@ionic/react';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Tab,
  Tabs,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { NavLink, useHistory, useParams } from 'react-router-dom';
import Script from 'next/script';
import { BookmakerDTO } from '../../models/common/BookmakerDTO';
import { RootState } from '../../models/RootState';
import {
  getAllMarketsByEvent,
  clearExchcngeBets,
  fetchOpenBets,
  fetchEvent,
  getSecondaryMarketsByEvent,
  setExchEvent,
  getSecondaryMatchOddsByEvent,
  updateEventScorecard,
  getCurrencyTypeFromToken,
  getBookmakerMarketsByEvent,
} from '../../store';
import EventsListMenu from '../../components/ExchEventsListMenu/ExchEventsListMenu';
import BmMTable from '../../components/ExchBookmakerMarketTable/ExchBookmakerMarketTable';
import FMTable from '../../components/ExchFancyMarketsTable/ExchFancyMarketsTable';
import MatchOddsTable from '../../components/ExchMatchOddsTable/ExchMatchOddsTable';
import ExchBetslip from '../../components/ExchBetslip/ExchBetslip';
import ExchOpenBets from '../../components/ExchOpenBets/ExchOpenBets';
import Scorecard from '../../components/Scorecard/Scorecard';
import CricketScorecardView from '../../components/Scorecard/CricketScorecardView';
import CricketLiveStream from '../../components/Livestream/CricketLiveStream';
import './ExchangeAllMarkets.scss';
import { UserBet } from '../../models/UserBet';
import TabPanel from '../../components/TabPanel/TabPanel';
import { formatDate } from '../../util/stringUtil';

import {
  SecondaryMarkets,
  SelectedObj,
} from '../../models/ExchangeSportsState';
import {
  subscribeWsForEventOdds,
  subscribeWsForSecondaryMarkets,
  subscribeWsForSecondaryMatchOdds,
  unsubscribeAllWsforEvents,
  isConnected,
  subscribeScorecard,
  checkStompClientSubscriptions,
  disconnectToWS,
  subscribeWsForFancyMarkets,
  isPushNotificationConnected,
  subscribeWsForNotifications,
  subscribeWsForNotificationsPerAdmin,
  subscribeWsForNotificationsPerAdminAllMarkets,
} from '../../webSocket/webSocket';
import { EventDTO } from '../../models/common/EventDTO';
import { MatchOddsDTO } from '../../models/common/MatchOddsDTO';
import { isIOS } from 'react-device-detect';
import API from '../../api';
import { CURRENCY_TYPE_FACTOR } from '../../constants/CurrencyTypeFactor';
import axios from 'axios';
import ExpandLessSharpIcon from '@material-ui/icons/ExpandLessSharp';
import SVLS_API from '../../svls-api';
import { updateBookMakerMarkets } from '../../store/exchangeSports/exchangeSportsActions';
import { PlaceBetRequest } from '../../models/BsData';
import API_SPORT_FEED from '../../api-services/sportsfeed-api';
import { getHouseIdFromToken, getParentIdFromToken, getSapTokenFromToken } from '../../store/auth/authActions';
import { PROVIDER_ID } from '../../constants/Branding';

// import { WORLD_CUP } from '../../constants/IPLEvent';

type StoreProps = {
  selectedEvent: SelectedObj;
  triggerFetchOrders: number;
  eventData: EventDTO;
  secondaryMatchOdds: MatchOddsDTO[];
  secondaryMarkets: SecondaryMarkets;
  bmMData: BookmakerDTO[];
  bets: PlaceBetRequest[];
  openBets: UserBet[];
  loggedIn: boolean;
  clearExchcngeBets: () => void;
  fetchOpenBets: (eventId: string, sportId: string) => void;
  fetchEvent: (
    sportId: string,
    competitionId: string,
    eventId: string,
    marketTime: string
  ) => void;
  setExchEvent: (event: SelectedObj) => void;
  updateEventScorecard: (scorecard: any) => void;
  selectedEventType: { id: ''; name: ''; slug: '' };
  topicUrls: any;
  langData : any;
  houseId: string;
  parentId: string;
  accountId: string;
  triggerFetchMarkets: number;
};

type RouteParams = {
  eventType: string;
  competition: string;
  eventId: string;
  eventInfo: string;
};

const ExchAllMarkets: React.FC<StoreProps> = (props) => {
  const {
    selectedEvent,
    triggerFetchOrders,
    eventData,
    secondaryMatchOdds,
    secondaryMarkets,
    bets,
    openBets,
    loggedIn,
    clearExchcngeBets,
    fetchOpenBets,
    fetchEvent,
    setExchEvent,
    updateEventScorecard,
    selectedEventType,
    bmMData,
    topicUrls,
    langData,
    houseId,
    parentId,
    accountId,
    triggerFetchMarkets
  } = props;
  
  const routeParams = useParams<RouteParams>();
  const [tabVal, setTabVal] = useState(1);
  const [streamAccordion, setStreamAccordion] = useState<boolean>(false);
  const [matchInfoAccordion, setMatchInfoAccordion] = useState<boolean>(false);
  const [openBetslip, setOpenBetslip] = useState<boolean>(true);
  const [backupStreamUrl, setBackupStreamUrl] = useState<string>(null);
  const [cFactor, setCFactor] = useState<number>(
    CURRENCY_TYPE_FACTOR[getCurrencyTypeFromToken()]
  );
  const [scorecardID, setScorecardID] = useState<string>('');
  const [virtualScorecard, setVirtualScorecard] = useState();
  const [exposureMap, setExposureMap] = useState(null);
  const [matchOddsBaseUrl, setMatchOddsBaseUrl] = useState<string>('');
  const [matchOddsTopic, setMatchOddsTopic] = useState<string>('');
  const [enableFetchOrders, setEnableFetchOrders] = useState<boolean>(false);
  const [bookMakerBaseUrl, setBookMakerBaseUrl] = useState<string>('');
  const [bookMakerTopic, setBookMakerTopic] = useState<string>('');
  const [fancyBaseUrl, setFancyBaseUrl] = useState<string>('');
  const [fancyTopic, setFancyTopic] = useState<string>('');
  // const cFactor = CURRENCY_TYPE_FACTOR[getCurrencyTypeFromToken()];

  // let scorecardScript = {
  //   __html: `
  //         (function(a,b,c,d,e,f,g,h,i){a[e]||(i=a[e]=function(){(a[e].q=a[e].q||[]).push(arguments)},i.l=1*new Date,i.o=f,
  //         g=b.createElement(c),h=b.getElementsByTagName(c)[0],g.async=1,g.src=d,g.setAttribute("n",e),h.parentNode.insertBefore(g,h)
  //         )})(window,document,"script", "https://widgets.sir.sportradar.com/8ee45b574e2781d581b0b0a133803906/widgetloader", "SIR", {
  //             theme: false, // using custom theme
  //             language: "en"
  //         });
  //         SIR("addWidget", ".sr-widget-1", "match.lmtPlus", {layout: "double", scoreboard: "extended", momentum: "extended", collapseTo: "momentum", matchId:${scorecardID}});
  //           `,
  // };

  const isMobile = window.innerWidth > 1120 ? false : true;
  // score card listener to change the height of iframe to its content
  useEffect(() => {
    window.addEventListener('message', (event) => {
      const element: HTMLIFrameElement = document.getElementById(
        'frame'
      ) as HTMLIFrameElement;

      if (element !== null && element !== undefined) {
        if (event && event.data && event.data.scoreWidgetHeight) {
          element.height = event.data.scoreWidgetHeight + 12;
        }
      }
    });
  }, []);

  useEffect(() => {
    updateBookMakerMarkets(bmMData);
  }, [bmMData]);

  useEffect(() => {
    unsubscribeAllWsforEvents();
  }, [selectedEvent]);

  useEffect(() => {
    if (!loggedIn) {
      unsubscribeAllWsforEvents();
    }
  }, [loggedIn]);

  const updateMatchOddsTopic = (
    currentTopic: string,
    currentBaseUrl: string
  ) => {
    if (
      matchOddsTopic !== currentTopic ||
      matchOddsBaseUrl !== currentBaseUrl
    ) {
      disconnectToWS();
      setMatchOddsTopic(currentTopic);
      setMatchOddsBaseUrl(currentBaseUrl);
    }
  };

  const updateBookMakerTopic = (
    currentTopic: string,
    currentBaseUrl: string
  ) => {
    if (
      bookMakerTopic !== currentTopic ||
      bookMakerBaseUrl !== currentBaseUrl
    ) {
      disconnectToWS();
      setBookMakerTopic(currentTopic);
      setBookMakerBaseUrl(currentBaseUrl);
    }
  };

  const updateFancyTopic = (currentTopic: string, currentBaseUrl: string) => {
    if (fancyTopic !== currentTopic || fancyBaseUrl !== currentBaseUrl) {
      disconnectToWS();
      setFancyTopic(currentTopic);
      setFancyBaseUrl(currentBaseUrl);
    }
  };

  useEffect(() => {
    if (loggedIn && eventData) {
      setCFactor(CURRENCY_TYPE_FACTOR[getCurrencyTypeFromToken()]);
      if (topicUrls?.matchOddsTopic) {
        updateMatchOddsTopic(
          topicUrls?.matchOddsTopic,
          topicUrls?.matchOddsBaseUrl
        );
        subscribeWsForEventOdds(
          topicUrls?.matchOddsTopic,
          eventData.sportId,
          eventData.competitionId,
          eventData.eventId,
          eventData.matchOdds.marketId,
          eventData.providerName,
          false
        );
      }
      subscribeScorecard(eventData.sportId, eventData.eventId);
      if (eventData.sportId === '4') {
        if (secondaryMarkets?.bookmakers?.length && topicUrls?.bookMakerTopic) {
          updateBookMakerTopic(
            topicUrls?.bookMakerTopic,
            topicUrls?.bookMakerBaseUrl
          );
          for (let itm of secondaryMarkets?.bookmakers) {
            subscribeWsForSecondaryMarkets(
              topicUrls?.bookMakerTopic,
              eventData?.eventId,
              itm.marketId
            );
          }
        }
        if (topicUrls?.fancyTopic) {
          updateFancyTopic(topicUrls?.fancyTopic, topicUrls?.fancyBaseUrl);
          subscribeWsForFancyMarkets(topicUrls?.fancyTopic, eventData?.eventId);
        }
      }
      if (topicUrls?.matchOddsTopic) {
        updateMatchOddsTopic(
          topicUrls?.matchOddsTopic,
          topicUrls?.matchOddsBaseUrl
        );
        for (let mo of secondaryMatchOdds) {
          subscribeWsForSecondaryMatchOdds(
            topicUrls?.matchOddsTopic,
            eventData.eventId,
            mo.marketId,
            eventData.providerName
          );
        }
      }
    }
  }, [isConnected(), selectedEvent, loggedIn]);

  useEffect(() => {
    if (isPushNotificationConnected() && loggedIn && eventData?.eventId) {
      subscribeWsForNotifications(
        false,
        houseId,
        eventData?.sportId,
        eventData?.competitionId,
        eventData?.eventId
      );
      subscribeWsForNotificationsPerAdminAllMarkets(
        false,
        houseId,
        parentId,
        accountId,
        eventData?.eventId
      );
      return () => {
        if (!window.location.pathname.includes('==')) {
          subscribeWsForNotificationsPerAdmin(
            false,
            houseId,
            parentId,
            accountId
          );
          subscribeWsForNotifications(false, houseId);
        }
      };
    }
  }, [isPushNotificationConnected(), loggedIn, eventData?.eventId]);

  useEffect(() => {
    if (
      eventData?.eventId &&
      eventData?.status === 'IN_PLAY' &&
      scorecardID === ''
    ) {
      loggedIn && getSPEventIdByBetfairId();
      if (eventData.sportId === '4') {
        getVirtualScoreCard(eventData.eventId);
      }
    }
  }, [eventData?.eventId]);

  const getVirtualScoreCard = async (eventId) => {
    try {
      const genieResponse = await axios.post(
        `https://api-genie.mysportsfeed.io/api/scorecard/`,
        { eventId: eventId, operatorId: '1' }
      );
      setVirtualScorecard(genieResponse.data.scoreUrl);
    } catch (err) {}
  };

  const getSPEventIdByBetfairId = async () => {
    try {
      await API_SPORT_FEED.post(`/feed/get-sr-event-details`, {
        eventId: eventData?.eventId,
        token: getSapTokenFromToken(),
      }).then((result) => {
        if (result?.data?.status === 'RS_OK')
          setScorecardID(
            result?.data?.srEventDetails?.srEventId?.split(':')[2]
          );
        else setScorecardID(null);
      });
    } catch (err) {
      setScorecardID(null);
    }
  };

  useEffect(() => {
    updateEventScorecard(null);
  }, [eventData?.eventId]);

  useEffect(() => {
    clearExchcngeBets();
    return () => {
      setExchEvent({ id: '', name: '', slug: '' });
    };
  }, []);


  useEffect(() => {
    if (loggedIn && enableFetchOrders && selectedEvent.id) {
      setTimeout(() => {
        fetchOpenBets(selectedEvent?.id, selectedEventType?.id);
        fetchOpenBetsRisk(selectedEvent?.id);
      }, 1000);
    }
    // }, [loggedIn, triggerFetchOrders, fetchOpenOrders]);
  }, [loggedIn, triggerFetchOrders]);

  useEffect(() => {
    const [sportId, competitionId, eventId, marketTime] = atob(
      routeParams.eventInfo
    ).split(':');
    if (loggedIn && eventId && !backupStreamUrl) {
      fetchStreamUrl(sportId, competitionId, eventId);
    }
  }, [loggedIn, routeParams]);

  // Fetch market prices from URL encoded param
  useEffect(() => {
    const [sportId, competitionId, eventId, marketTime] = atob(routeParams.eventInfo).split(
      ':'
    );
    fetchEvent(sportId, competitionId, eventId, marketTime);
    if (loggedIn && routeParams?.eventId) {
      setEnableFetchOrders(true);
      fetchOpenBets(eventId, sportId);
      fetchOpenBetsRisk(eventId);
    }
  }, [routeParams?.eventId]);

  useEffect(() => {
    if (eventData !== null) {
      fetchEvent(
        eventData?.sportId,
        eventData?.competitionId,
        eventData?.eventId,
        ''
      );
    }
  }, [triggerFetchMarkets]);

  useEffect(() => {
    let refreshInterval = setInterval(() => {
      fetchEvent(
        eventData?.sportId,
        eventData?.competitionId,
        eventData?.eventId,
        ''
      );
    }, 1000 * 30);
    return () => {
      clearInterval(refreshInterval);
    };
  }, [loggedIn, selectedEvent?.id]);

  useEffect(() => {
    if (eventData && (eventData.inPlay || eventData.status === 'IN_PLAY')) {
      setTabVal(0);
    } else if (openBets.length > 0) {
      setTabVal(2);
    } else {
      setTabVal(1);
    }
  }, []);

  useEffect(() => {
    if (!openBetslip && bets.length > 0) {
      setOpenBetslip(true);
    }
  }, [bets]);

  const fetchStreamUrl = async (
    sportId: string,
    competitionId: string,
    eventId: string
  ) => {
    try {
      const response = await SVLS_API.get(`/catalog/v2/live-stream-links/`, {
        headers: {
          Authorization: sessionStorage.getItem('jwt_token'),
        },
        params: {
          providerId: PROVIDER_ID,
          sportId: sportId,
          competitionId: competitionId,
          eventId: eventId,
        },
      });

      if (response.status === 200 && response.data) {
        setBackupStreamUrl(response.data);
      } else {
        setBackupStreamUrl(null);
      }
    } catch (err) {
      setBackupStreamUrl(null);
    }
  };

  // useEffect(() => {
  //   let refreshInterval = setInterval(() => {
  //     checkStompClientSubscriptions();
  //   }, 10000);
  //   return () => {
  //     clearInterval(refreshInterval);
  //   };
  // }, []);

  const fetchOpenBetsRisk = async (eventId: string) => {
    try {
      if (!eventId || !loggedIn) {
        return;
      }

      const response = await SVLS_API.get(
        '/reports/v2/risk-management/user-risk',
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
          },
          params: {
            eventId: eventId,
          },
        }
      );
      setExposureMap(response.data.marketExposureMap);
    } catch (e) {
      console.log(e);
    }
  };

  const getFormattedMaxLimit = (max: number) => {
    const num = Number(max / cFactor);
    const fMax = Number(Math.floor(num / 50) * 50);
    return fMax > 999 ? Number(fMax / 1000).toFixed() + 'K' : fMax.toFixed();
  };

  const getFormattedMinLimit = (min: number) => {
    const num = Number(min / cFactor);
    const fMin = Number(Math.ceil(num / 10) * 10);
    return fMin > 999 ? Number(fMin / 1000).toFixed() + 'K' : fMin.toFixed();
  };

  return (
    <div>
      {eventData ? (
        <IonRow className="eam-ctn">
          {!virtualScorecard && scorecardID ? (
            <Script
              strategy="afterInteractive"
              dangerouslySetInnerHTML={{
                __html: `
          (function(a,b,c,d,e,f,g,h,i){a[e]||(i=a[e]=function(){(a[e].q=a[e].q||[]).push(arguments)},i.l=1*new Date,i.o=f,
          g=b.createElement(c),h=b.getElementsByTagName(c)[0],g.async=1,g.src=d,g.setAttribute("n",e),h.parentNode.insertBefore(g,h)
          )})(window,document,"script", "https://widgets.sir.sportradar.com/8ee45b574e2781d581b0b0a133803906/widgetloader", "SIR", {
              theme: false, // using custom theme
              language: "en"
          });
          SIR("addWidget", ".sr-widget-1", "match.lmtPlus", {layout: "double", scoreboard: "extended", momentum: "extended", collapseTo: "momentum", matchId:${scorecardID}});
            `,
              }}
            />
          ) : null}

          <IonCol className="eam-competitions-menu-section">
            <div className="sticky-col">
              <EventsListMenu />
            </div>
          </IonCol>
          <IonCol className="mob-stream-section">
            <IonRow className="eam-info-header">
              <div>{eventData?.eventName}</div>
              <div className="event-date">
                {eventData ? formatDate(eventData.openDate) : null}
              </div>
            </IonRow>
            {loggedIn &&
            isMobile &&
            // eventData?.eventId !== WORLD_CUP.eventId &&
            (openBets.length > 0 ||
              (eventData &&
                (eventData.inPlay || eventData.status === 'IN_PLAY'))) ? (
              <Accordion
                className="stream-accordion mob-stream-accordion"
                expanded={matchInfoAccordion}
                onChange={(_, expanded) => {
                  setMatchInfoAccordion(expanded);
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon className="expand-icon" />}
                  aria-controls="panel1a-content"
                  className="stream-header"
                >
                  Score Card / Live Video / Open Bets
                </AccordionSummary>
                <AccordionDetails className="stream-body">
                  <Tabs
                    value={tabVal}
                    className="eam-all-markets-header-tabs"
                    onChange={(_, newValue) => {
                      setTabVal(newValue);
                    }}
                  >
                    <Tab label="Scorecard" value={0} />
                    <Tab
                      label="Live Stream"
                      value={1}
                      disabled={
                        !(
                          eventData &&
                          (eventData.inPlay || eventData.status === 'IN_PLAY')
                        )
                      }
                    />
                    <Tab
                      label={'Open Bets (' + openBets.length + ')'}
                      value={2}
                      // disabled={openBets.length < 1}
                    />
                  </Tabs>
                  <TabPanel
                    value={tabVal}
                    index={0}
                    className="event-stat-mobile-ctn"
                  >
                    <div>
                      {matchInfoAccordion &&
                      tabVal === 0 &&
                      eventData &&
                      eventData.matchOdds &&
                      (eventData.inPlay || eventData.status === 'IN_PLAY') ? (
                        <>
                          <Accordion
                            className="scorecard-accordion"
                            defaultExpanded={true}
                          >
                            <AccordionSummary
                              expandIcon={
                                <ExpandLessSharpIcon className="expand-icon" />
                              }
                              aria-controls="panel1a-content"
                              className="scorecard-header"
                            >
                              {langData?.['live_score']}
                            </AccordionSummary>
                            <AccordionDetails className="scorecard-detail">
                              <div className="widgets">
                                <div>
                                  <div className="sr-widget sr-widget-1"></div>
                                </div>
                              </div>
                            </AccordionDetails>
                          </Accordion>
                        </>
                      ) : null}
                    </div>
                  </TabPanel>
                  <TabPanel
                    value={tabVal}
                    index={1}
                    className="eam-header-tab-panel"
                  >
                    {matchInfoAccordion && tabVal === 1 ? (
                      <>
                        <div className="live-stream-ctn">
                          {/* {eventData.sportId === '4' ? ( */}
                          <CricketLiveStream
                            eventID={eventData.eventId}
                            providerUrl={backupStreamUrl}
                          />
                          {/* ) : (
                            <iframe
                              title="mob-live-stream"
                              allowFullScreen={false}
                              src={`https://tvlivestreaming.online/live_tv/index.html?eventId=${eventData.eventId}`}
                              sandbox="allow-same-origin allow-forms allow-scripts allow-top-navigation allow-popups"
                            ></iframe>
                          )} */}
                        </div>
                      </>
                    ) : null}
                  </TabPanel>
                  <TabPanel
                    value={tabVal}
                    index={2}
                    className="eam-header-tab-panel"
                  >
                    {openBets.length > 0 ? (
                      <ExchOpenBets />
                    ) : (
                      <div className="no-open-bets">No Open Bets</div>
                    )}
                  </TabPanel>
                </AccordionDetails>
              </Accordion>
            ) : null}
          </IonCol>

          <IonCol className="eam-events-table-section">
            <IonRow className="eam-info-header">
              <div>{eventData?.eventName}</div>
              <div className="event-date">
                {eventData ? formatDate(eventData.openDate) : null}
              </div>
            </IonRow>
            {loggedIn &&
            !isMobile &&
            // eventData?.eventId !== WORLD_CUP.eventId &&
            eventData &&
            eventData.matchOdds &&
            (eventData.inPlay || eventData.status === 'IN_PLAY') ? (
              <Accordion className="scorecard-accordion" defaultExpanded={true}>
                <AccordionSummary
                  expandIcon={<ExpandLessSharpIcon className="expand-icon" />}
                  aria-controls="panel1a-content"
                  className="scorecard-header"
                >
                  {langData?.['live_score']}
                </AccordionSummary>
                <AccordionDetails className="scorecard-detail">
                  <div className="widgets">
                    <div>
                      <div className="sr-widget sr-widget-1"></div>
                    </div>
                  </div>
                </AccordionDetails>
              </Accordion>
            ) : null}

            <IonRow className="eam-table-section">
            {eventData.providerName.toLowerCase() !== 'sportradar' && (
              <MatchOddsTable
                exposureMap={exposureMap ? exposureMap : null}
                loggedIn={loggedIn}
                getFormattedMinLimit={getFormattedMinLimit}
                getFormattedMaxLimit={getFormattedMaxLimit}
                eventData={eventData}
                fetchEvent={fetchEvent}
                secondaryMatchOdds={secondaryMatchOdds}
              />
            )}
            </IonRow>
            {secondaryMarkets?.bookmakers?.length > 0 &&
            secondaryMarkets?.bookmakers[0].runners.length > 0 ? (
              <>
                <IonRow className="eam-section-divider"></IonRow>
                <IonRow className="eam-table-section">
                <BmMTable
                  enableBookmaker={secondaryMarkets?.enableBookmaker}
                  loggedIn={loggedIn}
                  getFormattedMinLimit={getFormattedMinLimit}
                  getFormattedMaxLimit={getFormattedMaxLimit}
                  bmMData={bmMData}
                  eventData={eventData}
                  exposureMap={exposureMap ? exposureMap : null}
                  // fetchEvent={fetchEvent}
                />
                </IonRow>
              </>
            ) : null}
            {secondaryMarkets?.fancyMarkets?.length > 0 ? (
              <>
                <IonRow className="eam-section-divider"></IonRow>
                <IonRow className="eam-table-section">
                  <FMTable
                    loggedIn={loggedIn}
                    getFormattedMinLimit={getFormattedMinLimit}
                    getFormattedMaxLimit={getFormattedMaxLimit}
                    exposureMap={exposureMap ? exposureMap : null}
                    fetchEvent={fetchEvent}
                  />
                </IonRow>
              </>
            ) : null}
          </IonCol>

          {!isMobile ? (
            <IonCol className="stream-section">
              <div className="sticky-col">
                {loggedIn &&
                eventData &&
                (eventData.inPlay || eventData.status === 'IN_PLAY') ? (
                  <Accordion
                    className="stream-accordion"
                    expanded={streamAccordion}
                    onChange={(_, expanded) => {
                      // setPlayStream(expanded);
                      setStreamAccordion(expanded);
                    }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon className="expand-icon" />}
                      aria-controls="panel1a-content"
                      className="stream-header"
                    >
                       {langData?.['live_stream']}
                    </AccordionSummary>
                    <AccordionDetails className="stream-body">
                      {/* {streamAccordion ? (
                        <> */}
                          <div className="live-stream-ctn">
                            <CricketLiveStream
                              eventID={eventData.eventId}
                              providerUrl={backupStreamUrl}
                            />
                          </div>
                        {/* </>
                      ) : null} */}
                    </AccordionDetails>
                  </Accordion>
                ) : null}
                <Accordion
                  className="stream-accordion"
                  expanded={openBetslip}
                  onChange={(_, expanded) => setOpenBetslip(expanded)}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon className="expand-icon" />}
                    aria-controls="panel1a-content"
                    className="stream-header"
                  >
                     {langData?.['bet_slip']} ({bets.length})
                  </AccordionSummary>
                  <AccordionDetails className="stream-body">
                    {bets.length > 0 ? <ExchBetslip /> : null}
                  </AccordionDetails>
                </Accordion>
                {loggedIn ? (
                  <Accordion
                    className="stream-accordion"
                    defaultExpanded={true}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon className="expand-icon" />}
                      aria-controls="panel1a-content"
                      className="stream-header"
                    >
                     {langData?.['open_bets']} ({openBets.length})
                    </AccordionSummary>
                    <AccordionDetails className="stream-body">
                      {openBets.length > 0 ? <ExchOpenBets /> : null}
                    </AccordionDetails>
                  </Accordion>
                ) : null}
              </div>
            </IonCol>
          ) : null}
        </IonRow>
      ) : null}

      <div
        className={isIOS ? 'betslip-section ios-betslip' : 'betslip-section'}
      >
        <Accordion
          className="stream-accordion"
          expanded={openBetslip}
          onChange={(_, expanded) => setOpenBetslip(expanded)}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon className="expand-icon" />}
            aria-controls="panel1a-content"
            className="stream-header"
          >
            {langData?.['bet_slip']} ({bets.length})
          </AccordionSummary>
          <AccordionDetails className="stream-body">
            {bets.length > 0 ? <ExchBetslip /> : null}
          </AccordionDetails>
        </Accordion>
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState, ownProps) => {
  const selectedEvent = state.exchangeSports.selectedEvent;
  return {
    eventData: getAllMarketsByEvent(
      state.exchangeSports.events,
      state.exchangeSports.selectedEventType.id,
      state.exchangeSports.selectedCompetition.id,
      selectedEvent.id
    ),
    secondaryMarkets: getSecondaryMarketsByEvent(
      state.exchangeSports.secondaryMarketsMap,
      selectedEvent.id
    ),
    secondaryMatchOdds: getSecondaryMatchOddsByEvent(
      state.exchangeSports.secondaryMatchOddsMap,
      selectedEvent.id
    ),
    selectedEvent: selectedEvent,
    bets: state.exchBetslip.bets,
    openBets: state.exchBetslip.openBets,
    loggedIn: ownProps.loggedIn,
    streamUrl: state.common.streamUrl,
    selectedEventType: state.exchangeSports.selectedEventType,
    langData:state.common.langData,
    bmMData: getBookmakerMarketsByEvent(
      state.exchangeSports.secondaryMarketsMap,
      selectedEvent.id
    ),
    topicUrls: state?.exchangeSports?.topicUrls,
    triggerFetchOrders: state.exchangeSports.triggerFetchOrders,
    houseId: getHouseIdFromToken(),
    parentId: getParentIdFromToken(),
    accountId: sessionStorage.getItem('aid'),
    triggerFetchMarkets: state.exchangeSports.triggerFetchMarkets,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    clearExchcngeBets: () => dispatch(clearExchcngeBets()),
    fetchOpenBets: (eventId: string, sportId: string) =>
      dispatch(fetchOpenBets(eventId, sportId)),
    setExchEvent: (event: SelectedObj) => dispatch(setExchEvent(event)),
    updateEventScorecard: (scorecard: any) =>
      dispatch(updateEventScorecard(scorecard)),
    fetchEvent: (
      sportId: string,
      competitionId: string,
      eventId: string,
      marketTime: string
    ) => dispatch(fetchEvent(sportId, competitionId, eventId, marketTime)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ExchAllMarkets);
